module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_placeholder":"Review keyword search"}}')
  delete Component.options._Ctor
}
